import { Component, HostListener, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ConcessionarioPessoaStatus } from '@tivic-team/manager-ts/dist/mob/enums/concessionario-pessoa/concessionario-pessoa-status';
import { ConcessionarioPessoaDTO } from 'app/model/dtos/mob/concessionario-pessoa.dto';
import { ConcessionarioPessoaService } from 'app/services/mob/concessionario-pessoa.service';
import { ModalService } from 'app/tools/modal/modal.service';
import { DialogFactory } from 'sol-tools-ts/dist';
import { ModalDesativarComponent } from '../modal-desativar/modal-desativar.component';
import { ResultConcessionarioBuilder } from './result-concessionario.builder';

@Component({
  selector: 'button-salvar-situacao',
  templateUrl: './button-salvar-situacao.component.html',
  styleUrls: ['./button-salvar-situacao.component.scss']
})
export class ButtonSalvarSituacaoComponent implements OnInit {

  @Input() dtInativacaoControl: FormControl;
  @Input() params: any;
  cdConcessao: number;


  @HostListener('document:keydown.enter', ['$event']) onDoneClick(event: KeyboardEvent){
    event.preventDefault();
    this.desativar();
  }

  constructor(
    private _concessionarioPessoaService: ConcessionarioPessoaService,
    private _modalService: ModalService<ModalDesativarComponent>,
    private _activatedRoute: ActivatedRoute,
    private _dialogFactory: DialogFactory,
    private _router: Router
  ) { }

  ngOnInit() { }

  async desativar(){
    try{
      if(!this.dtInativacaoControl.valid){
        this.dtInativacaoControl.markAllAsTouched();
        return this._dialogFactory.snack('A data de inativação precisa ser maior que a data de ativação!', 'OK', DialogFactory.SNACK_ERROR, { duration: 6000 });
      }
      let concessionarioPessoaDTO: ConcessionarioPessoaDTO = this.params;
      this.buildSituacao(concessionarioPessoaDTO);
      this.setDtInativacao(concessionarioPessoaDTO);
      concessionarioPessoaDTO = await this._concessionarioPessoaService.desativar(concessionarioPessoaDTO);
      this._dialogFactory.snack('A desativação foi realizada com sucesso!', 'OK', DialogFactory.SNACK_SUCCESS, { duration: 3000 });
      new ResultConcessionarioBuilder(this._activatedRoute, this._dialogFactory, this._router).build(concessionarioPessoaDTO);
      this._modalService.dismiss();
    } catch (error){
      this._dialogFactory.snack(error.message, 'OK', DialogFactory.SNACK_ERROR, { duration: 5000 });
    }
  }

  buildSituacao(concessionarioPessoaDTO: ConcessionarioPessoaDTO){
    if(concessionarioPessoaDTO != undefined)
      concessionarioPessoaDTO.stConcessionarioPessoa = ConcessionarioPessoaStatus.INATIVO;
  }

  setDtInativacao(concessionarioPessoaDTO: ConcessionarioPessoaDTO) {
    if(!this.params.dtInativacao)
      concessionarioPessoaDTO.dtInativacao = this.dtInativacaoControl.value;
  }

  redirectTo(uri: Array<any>) {
    this._router.navigateByUrl('/', { skipLocationChange: true }).then(() => this._router.navigate(uri));
  }
}
